<div [ngStyle]="{ 'min-width': getValue(minWidth), width: getValue(width) }">
  <!-- bouton -->
  <div style="margin-bottom: 5px" class="display-Flex">
    <div [innerHtml]="titre"></div>
    <div>
      <div id="listBtn" *ngIf="!disabled">
        <ng-container
          *ngIf="
            !usePhoneTemplate || (!isVersionPortable() && usePhoneTemplate)
          "
        >
          <ng-container *ngFor="let btn of listBtn">
            <button
              [disabled]="btn.disabled"
              [name]="btn.name"
              (click)="clickBtnHeat($event, btn)"
              mat-raised-button
              [ngClass]="btn.class"
            >
              <mat-icon *ngIf="btn.icon != undefined && btn.icon != null">{{
                btn.icon
              }}</mat-icon
              >{{ btn.text }}
            </button>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- colonne -->

  <div class="display-Flex-2 py-3 border border-gray-300 border-b-0">
    <!-- pour recuperé le width scrol -->
    <div
      *ngIf="isScrol() && positionScrol && positionScrol == 'rtl'"
      style="width: 11px"
    ></div>
    <div
      *ngIf="showChekcboxes"
      id="checkboxMain"
      name="checkboxMain"
      style="width: 2vw"
    ></div>
    <div [ngStyle]="getStyle(column)" *ngFor="let column of columns.TableRD">
      <ng-container *ngIf="showFilter">
        <mat-form-field
          floatLabel="always"
          [ngStyle]="getStyleColonne(column)"
          appearance="outline"
        >
          <mat-label>{{ column.TableRD_Des }}</mat-label>
          <input
            style="color: black"
            matInput
            [ngClass]="'inputSearch' + randomNumber"
            (keyup)="filterData($event, column, 'filterData')"
            [name]="column.TableRD_Champs"
          />
          <button
            *ngIf="showSort"
            (click)="sort($event, column, 'sort')"
            matSuffix
            mat-icon-button
          >
            <mat-icon>{{
              column.iconSort ? column.iconSort : "sort"
            }}</mat-icon>
          </button>
        </mat-form-field>
      </ng-container>

      <div *ngIf="!showFilter" class="display-Flex">
        <div>
          <b class="px-4">{{ column.TableRD_Des }}</b>
        </div>
        <img
          *ngIf="showSort"
          style="height: 15px; cursor: pointer"
          (click)="sort($event, column, 'sort')"
          [src]="'./assets/' + column.iconSort + '.png'"
        />
      </div>
    </div>
  </div>
  <div [id]="'my-liste-respancive' + randomNumber">
    <cdk-virtual-scroll-viewport
      itemSize="40"
      class="display-Flex-2 entet-liste3"
    >
      <div
        *ngIf="showHeader"
        class="flex overflow-auto py-8 gap-x-1 bg-gray-800 text-white"
        style="padding-left: 25px; padding-right: 25px"
      >
        <div
          class="text-center uppercase font-semibold"
          style="width: 100px"
          *ngFor="let column of columns.TableRD"
        >
          {{ column.TableRD_Des }}
        </div>
      </div>
      <div
        *cdkVirtualFor="let row of getDataSource(); let i = index"
        dir="ltr"
        [id]="'row_' + randomNumber + '_' + i"
        (click)="clickRow(row, i, $event)"
        (dblclick)="dbClick($event, row, i)"
        class="my-card py-4 flex"
        [class]="
          rowIndex == i
            ? 'selected-row'
            : getActifClass_selectedList(row, 'selected-row')
        "
        style="min-height: 60px; text-align-last: center"
      >
        <mat-checkbox
          *ngIf="showChekcboxes"
          [id]="'row_' + randomNumber + '_' + i"
          name="checkboxList"
          [value]="row"
          (change)="onSelectCheckBox($event, i)"
        >
        </mat-checkbox>
        <div class="display-Flex">
          <div [id]="'aa-' + i" class="display-Flex-2">
            <div
              class="my-coll"
              (click)="clickColonne(column, $event)"
              [ngStyle]="getStyle(column)"
              *ngFor="let column of columns.TableRD"
            >
              <div
                *ngIf="
                  column.TableRD_Type == 0 ||
                  column.TableRD_Type == 4 ||
                  column.TableRD_Type == 6
                "
                [ngStyle]="getStyleColonne(column)"
              >
                <mat-form-field
                  *ngIf="ifWrap()"
                  [ngStyle]="getStyleColonne(column)"
                  appearance="outline"
                >
                  <mat-label>{{ column.TableRD_Des }}</mat-label>
                  <input
                    readonly="true"
                    matInput
                    [name]="'input_' + column.TableRD_Champs"
                    [ngModel]="
                      column.TableRD_Type == 4
                        ? (row[column.TableRD_Champs]
                          | date : column.TableRD_Format)
                        : column.TableRD_Type == 6
                        ? (row[column.TableRD_Champs]
                          | number : column.TableRD_Format)
                        : row[column.TableRD_Champs]
                    "
                    [placeholder]="column.TableRD_Des"
                  />
                </mat-form-field>
                <div *ngIf="!ifWrap()">
                  {{
                    column.TableRD_Type == 4
                      ? (row[column.TableRD_Champs]
                        | date : column.TableRD_Format)
                      : column.TableRD_Type == 6
                      ? (row[column.TableRD_Champs]
                        | number : column.TableRD_Format)
                      : row[column.TableRD_Champs]
                  }}
                </div>
              </div>
              <div
                *ngIf="column.TableRD_Type == 7"
                [ngStyle]="getStyleColonne(column)"
              >
                <div
                  [innerHTML]="
                    sanitizer.bypassSecurityTrustHtml(
                      row[column.TableRD_Champs]
                    )
                  "
                ></div>
              </div>
              <div
                *ngIf="column.TableRD_Type == 8"
                [ngStyle]="getStyleColonne(column)"
              >
                <span
                  style="cursor: pointer"
                  (click)="clickBtnListe(row, column, $event)"
                >
                  <mat-icon color="primary">{{
                    row[column.TableRD_Champs]
                  }}</mat-icon>
                </span>
              </div>
            </div>
          </div>
          <div
            *ngIf="
              listBtn.length > 0 &&
              usePhoneTemplate &&
              isVersionPortable() &&
              !disabled
            "
          >
            <button [matMenuTriggerFor]="menu" mat-icon-button>
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
  <div
    *ngIf="customFooter"
    [ngStyle]="customFooter.style ? customFooter.style : {}"
  >
    <div *ngFor="let footer of customFooter.listeFooter; let i = index">
      <div style="min-height: 25px" class="display-Flex-2">
        <!-- pour recuperé le width scrol -->
        <div
          *ngIf="isScrol() && positionScrol && positionScrol == 'rtl'"
          style="width: 17px"
        ></div>
        <div *ngFor="let c of footer.colonne; let j = index">
          <div [ngStyle]="c.style ? c.style : {}">
            {{ c.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <mat-menu #menu="matMenu">
    <section class="user-menu">
      <ng-container *ngFor="let btn of listBtn">
        <div *ngIf="!btn.disabled" (click)="clickBtnHeat($event, btn)">
          <!-- <mat-icon   [ngClass]="btn.class" *ngIf="btn.icon != undefined && btn.icon != null">{{btn.icon}}</mat-icon> -->
          {{ btn.text }}
        </div>
      </ng-container>
    </section>
  </mat-menu>
  <div *ngFor="let a of liste"></div>
</div>
